"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelativePointerPosition = getRelativePointerPosition;
exports.isMouseOverNode = isMouseOverNode;
function getRelativePointerPosition(node) {
  // the function will return pointer position relative to the passed node

  // copy the current transforn on the node
  var transform = node.getAbsoluteTransform().copy();

  // determine relative position by inverting the transform
  transform.invert();

  // get pointer (say mouse or touch) position
  var pos = node.getStage().getPointerPosition();

  // return the relative point
  return transform.point(pos);
}
function isMouseOverNode(node) {
  var stage = node.getStage();
  var absolutePosition = stage.getPointerPosition();
  var boundingBox = node.getClientRect();
  return absolutePosition.x >= boundingBox.x && absolutePosition.x <= boundingBox.x + boundingBox.width && absolutePosition.y >= boundingBox.y && absolutePosition.y <= boundingBox.y + boundingBox.height;
}